module.exports = __webpack_public_path__ + "fd029bc705d3bcaa28735b51e538fd2a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/activity/detail-bg.jpg
// module id = 1095
// module chunks = 0